class BackToTop extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
        
        cursor: pointer;
      }
    `
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', (event) => {
      event.preventDefault()

      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  }
}

if (!window.customElements.get('back-to-top')) {
  window.customElements.define('back-to-top', BackToTop)
}
